import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { fonts, media } from '@blend/consumer-components';
import * as deploymentColors from 'login-stylesheets/deploymentColors';
import ContextLink from 'login-components/Common/ContextLink';

const styles = StyleSheet.create({
  wrapper: {
    ...fonts.Gotham,
    margin: 20,
    fontSize: 14,
    textAlign: 'center',
    color: deploymentColors.loginBackgroundDynamicColor,
    [media.smallViewMaxWidth]: {
      fontSize: 13,
    },
  },
  link: {
    fontWeight: fonts.weight.medium,
    color: deploymentColors.loginBackgroundDynamicColor,
  },
});

class AppFooter extends React.Component<{ config: FooterConfig; id: string }, {}> {
  render() {
    const { config, id } = this.props;
    if (!config.shouldRender()) {
      return null;
    }

    return (
      <footer id={id} className={css(styles.wrapper)}>
        <span>{config.description}</span>&nbsp;
        <ContextLink className={css(styles.link)} to={config.link.state} id={config.link.id}>
          {config.link.text}
        </ContextLink>
      </footer>
    );
  }
}

export default AppFooter;
